import { render, staticRenderFns } from "./HepsiburadaKategori.vue?vue&type=template&id=dee53f14&scoped=true&"
import script from "./HepsiburadaKategori.vue?vue&type=script&lang=js&"
export * from "./HepsiburadaKategori.vue?vue&type=script&lang=js&"
import style0 from "./HepsiburadaKategori.vue?vue&type=style&index=0&id=dee53f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee53f14",
  null
  
)

export default component.exports